import $ from "jquery";

export const productDetailsTabs = () => {
  const $tabContainer = $(".tab-section");

  if ($tabContainer.length > 0) {
    $.each($tabContainer, function () {
      const classList = $(this).attr("class").split(/\s+/);
      const prefix = classList[0].split("__")[0];
      const $tabSection = $(this);
      const $tabList = $tabSection.find(`.${prefix}__tab-list`);
      const $tabs = $tabSection.find(`.${prefix}__tab`);
      const $panelList = $tabSection.find(`.${prefix}__panel-list`);
      const $panels = $tabSection.find(`.${prefix}__panel`);

      //Switch between tab labels on desktop and select dropdown on mobile
      responsiveList($tabs, $tabList, $tabSection, $panels, $panelList, prefix);

      //listen for resize to switch between layouts
      var resizeTimer;
      $(window).on("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          responsiveList(
            $tabs,
            $tabList,
            $tabSection,
            $panels,
            $panelList,
            prefix
          );
        }, 500);
      });
    });
  }

  function responsiveList(
    $tabs,
    $tabList,
    $tabSection,
    $panels,
    $panelList,
    prefix
  ) {
    let tabFocus = 0;
    //Handling non-mobile screen sizes
    if ($(window).width() > 440) {
      //Check to see if select is on screen indicating a switch from mobile
      let $findDrop = $(`.${prefix}__select-div`);

      if ($findDrop) {
        $findDrop.replaceWith($tabList);
      }

      //Click Handler
      $.each($tabs, function (index) {
        const $tab = $(this);

        $tab.on("click", function (e) {
          const $currTab = $(this);

          tabFocus = index;

          $currTab
            .addClass("active")
            .attr("aria-selected", "true")
            .attr("tabindex", 0);

          $tabs
            .not($currTab)
            .removeClass("active")
            .attr("aria-selected", "false")
            .attr("tabindex", -1);

          const $currPanel = $tabSection.find(
            `#${$currTab.attr("aria-controls")}`
          );

          $currPanel.prop({ hidden: false });

          $panels.not($currPanel).prop({ hidden: true });
        });
      });
    } else {
      //create select dropdown from tab labels and replace tab labels
      const $selectWrapper = $(`<div class="${prefix}__select-div" />`);

      const $select = $(`<select class="${prefix}__tab-list" /> `);

      $.each($tabs, function () {
        const $tab = $(this);
        const $tabName = $tab.text().trim();
        let $option = $(`<option class='${$tab[0].className}' />`);

        $option.attr("value", $tab.attr("id")).html($tabName);

        $option
          .attr("id", $tab.attr("id"))
          .attr("aria-selected", $tab.attr("aria-selected"))
          .attr("aria-controls", $tab.attr("aria-controls"))
          .attr("role", $tab.attr("role"))
          .attr("tabindex", $tab.attr("tabindex"));

        $select.append($option);
      });

      $selectWrapper.append($select);

      $tabList.replaceWith($selectWrapper);

      //Dropdown change handler
      $select.on("change", function (e) {
        let $target = e.target.value;
        const $currOption = $tabSection.find(`option[id='${$target}']`);
        const $currPanel = $panelList.find(`div[aria-labelledby='${$target}']`);

        $currOption
          .attr("tabindex", 0)
          .addClass("active")
          .attr("aria-selected", "true")
          .attr("tabindex", 0);

        $select
          .find("option")
          .not($currOption)
          .removeClass("active")
          .attr("aria-selected", "false")
          .attr("tabindex", -1);

        $currPanel.prop({ hidden: false }).attr("tabindex", 0);

        $panels.not($currPanel).prop({ hidden: true }).attr("tabindex", -1);
      });
    }

    //key handler
    $tabList.on("keyup", function (e) {
      if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
        $tabs[tabFocus].setAttribute("tabindex", -1);
        $tabs[tabFocus].classList.toggle("active");
        $panels[tabFocus].setAttribute("hidden", "");

        if (e.key === "ArrowRight") {
          tabFocus++;
          // If we're at the end, go to the start
          if (tabFocus >= $tabs.length) {
            tabFocus = 0;
          }
        }
        if (e.key === "ArrowLeft") {
          tabFocus--;
          // If we're at the start, move to the end
          if (tabFocus < 0) {
            tabFocus = $tabs.length - 1;
          }
        }
      }

      $tabs[tabFocus].setAttribute("tabindex", 0);
      $panels[tabFocus].removeAttribute("hidden");
      $tabs[tabFocus].classList.toggle("active");
      $tabs[tabFocus].focus();
    });
  }

  window.addEventListener('load', function () {
    let downloadUrl = "";
    let downloadTitle = "";

    // Capture download link and title when a download button is clicked
    document
      .querySelectorAll(".product-downloads__button")
      .forEach((button) => {
        button.addEventListener("click", function () {
          downloadUrl = this.getAttribute("data-file");
          downloadTitle = this.getAttribute("data-title") || "download";
        });
      });

    const form = document.getElementById("downloadForm");
    const formMessage = document.getElementById("formMessage");
    const modal = document.getElementById("downloadModal");

    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();

        // Get form data
        const name = document.getElementById("name").value;
        const email = document.getElementById("email").value;
        const phone = document.getElementById("Phone").value;
        const industry = document.getElementById("Industry").value;
        const tag = document.getElementById("Tag").value;
        const hp = document.getElementById("hp").value;

        // Basic validation
        if (!name || !email) {
          formMessage.textContent = "Name and email are required.";
          formMessage.style.display = "block";
          return;
        }
        if (hp) {
          formMessage.textContent = "Invalid submission.";
          formMessage.style.display = "block";
          return;
        }
        if (!downloadUrl) {
          formMessage.textContent = "No download file selected.";
          formMessage.style.display = "block";
          return;
        }

        // Sendy API configuration
        const sendyAPIUrl =
          "https://marketing.laserphotonics.com/subscribe";
        const apiKey = "z3p8V3s2lBsRzNtHg3Pg"; // REPLACE
        const listId = "XpI0CJtS5165RHWmY3zzVQ";

        // Prepare data
        const data = new URLSearchParams();
        data.append("api_key", apiKey);
        data.append("name", name);
        data.append("email", email);
        data.append("Phone", phone);
        data.append("Industry", industry);
        data.append("Tag", tag);
        data.append("list", listId);
        data.append("silent", "true");

        // Send API request
        fetch(sendyAPIUrl, {
          method: "POST",
          body: data,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          mode: "no-cors",
        })
          .then(() => {
            console.log("Data sent to Sendy.");

            // Trigger file download
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.download = downloadTitle;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Close modal (if using Bootstrap)
            jQuery("#closeModal").click();

            // Redirect to thank-you page
            // window.location.href =
            //   "https://cmslaser.com/thank-you-for-subscribing/";
          })
          .catch((error) => {
            console.log("Error:", error);
            // formMessage.textContent =
            //   "Error submitting form. Please try again.";
            // formMessage.style.display = "none";
          });
      });
    } else {
      console.error("Form not found.");
    }
  });
};
